import { all, takeLeading } from "redux-saga/effects";
import {
  DELETE_USER_PASSENGER,
  FETCH_CORP_USER_PASSENGERS,
  UPDATE_USER_PASSENGER,
} from "../app/actions";
import {
  deleteUserPassengerSaga,
  fetchCorpUserPassengersSaga,
  updateUserPassengerSaga,
} from "./user-passenger";

export function* watchUpdateUserPassenger() {
  yield takeLeading(UPDATE_USER_PASSENGER, updateUserPassengerSaga);
}

export function* watchDeletePassengerSaga() {
  yield takeLeading(DELETE_USER_PASSENGER, deleteUserPassengerSaga);
}

export function* watchFetchUserPassengers() {
  yield takeLeading(FETCH_CORP_USER_PASSENGERS, fetchCorpUserPassengersSaga);
}

export function* rootSaga() {
  yield all([
    watchUpdateUserPassenger(),
    watchDeletePassengerSaga(),
    watchFetchUserPassengers(),
  ]);
}
